import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4 mb-3" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-8 mb-3" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-6 mb-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { class: "col-md-3 mb-3" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "col-md-12 mt-3" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = {
  ref: "submitButton",
  class: "btn btn-success me-3",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Ajouter une fiche de stock")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "ficheStockForm",
        onSubmit: _ctx.addFicheStock,
        "validation-schema": _ctx.ficheStockSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("label", {
                  for: "date",
                  class: "d-block text-black fw-semibold mb-10"
                }, [
                  _createTextVNode("Date création"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "dateCreation",
                  value: _ctx.getCurrentDate(),
                  class: "form-control",
                  type: "Date"
                }, null, 8, ["value"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateCreation",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Produit ", -1)),
                _createVNode(_component_Field, {
                  name: "produit",
                  modelValue: _ctx.produit,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.produit) = $event)),
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.produitOptions,
                      searchable: true,
                      placeholder: "Sélectionner un produit",
                      onSelect: ($event: any) => (_ctx.selectProd(field.value))
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "onSelect"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "produit",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black" }, [
                  _createTextVNode(" Magasin "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "magasin",
                  modelValue: _ctx.magasins,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.magasins) = $event)),
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.magasinOptions,
                      "preserve-search": true,
                      mode: "tags",
                      multiple: false,
                      searchable: true,
                      placeholder: "Sélectionner le magasin ",
                      label: "label",
                      "track-by": "label"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "magasin",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[5] || (_cache[5] = _createElementVNode("label", {
                for: "stockInit",
                class: "d-block text-black fw-semibold mb-10"
              }, "Stock Initial", -1)),
              _createVNode(_component_Field, {
                name: "stockInit",
                class: "form-control",
                type: "text"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "stockInit",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                  _createTextVNode(" Unité de suivie "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "conditionnement",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.conditionnementOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      placeholder: "Sélectionner le conditionnement"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "conditionnement",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", _hoisted_15, " Ajouter une fiche ", 512),
                _createVNode(_component_router_link, {
                  to: "/fiches/liste-fiches",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}